import { getColor } from '../utils';

import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const SMSSendSkip = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 24 24" {...props}>
    <g clipPath="url(#clip0_3173_50264)">
      <path
        d="M11.4368 15.9375C11.4368 16.5284 11.5532 17.1136 11.7793 17.6596C12.0055 18.2055 12.3369 18.7016 12.7548 19.1195C13.1727 19.5373 13.6687 19.8688 14.2147 20.095C14.7607 20.3211 15.3458 20.4375 15.9368 20.4375C16.5277 20.4375 17.1129 20.3211 17.6588 20.095C18.2048 19.8688 18.7009 19.5373 19.1187 19.1195C19.5366 18.7016 19.8681 18.2055 20.0942 17.6596C20.3204 17.1136 20.4368 16.5284 20.4368 15.9375C20.4368 15.3466 20.3204 14.7614 20.0942 14.2154C19.8681 13.6695 19.5366 13.1734 19.1187 12.7555C18.7009 12.3377 18.2048 12.0062 17.6588 11.78C17.1129 11.5539 16.5277 11.4375 15.9368 11.4375C15.3458 11.4375 14.7607 11.5539 14.2147 11.78C13.6687 12.0062 13.1727 12.3377 12.7548 12.7555C12.3369 13.1734 12.0055 13.6695 11.7793 14.2154C11.5532 14.7614 11.4368 15.3466 11.4368 15.9375V15.9375Z"
        stroke={getColor(color, isColorInherited)}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.6243 14.25L14.2493 17.625"
        stroke={getColor(color, isColorInherited)}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.2493 14.25L17.6243 17.625"
        stroke={getColor(color, isColorInherited)}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.16725 17.925L5.8125 20.4375V17.0625H4.6875C4.38913 17.0625 4.10298 16.944 3.892 16.733C3.68103 16.522 3.5625 16.2359 3.5625 15.9375V4.6875C3.5625 4.38913 3.68103 4.10298 3.892 3.892C4.10298 3.68103 4.38913 3.5625 4.6875 3.5625H19.3125C19.6109 3.5625 19.897 3.68103 20.108 3.892C20.319 4.10298 20.4375 4.38913 20.4375 4.6875V10.3125"
        stroke={getColor(color, isColorInherited)}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3173_50264">
        <rect width="18" height="18" fill="white" transform="translate(3 3)" />
      </clipPath>
    </defs>
  </SvgIcon>
);
